import { createI18n } from 'vue-i18n';

// import getMessages from '%_/translations.js';

// // Сообщения для поддерживаемых языков
// const messages = {
//    en: {
//       message: {
//          hello: 'Hello World'
//       }
//    },
//    fr: {
//       message: {
//          hello: 'Bonjour le monde'
//       }
//    },
//    // Добавьте другие языки по мере необходимости
// };


const messages = window.messagesDict

// Создание экземпляра i18n
const i18n = createI18n({
   locale: 'ru', // язык по умолчанию
   fallbackLocale: 'ru', // запасной язык
   messages,
});

export function setLanguage(lang) {
   i18n.global.locale = lang; // Обратите внимание на обновленный синтаксис для Vue 3
}

export default i18n;
